module.exports = __webpack_public_path__ + "img/symbol_11.f8fc5064.png";